<template>
    <div class="secondary ma-3 text-xs-center pa-3 subheading elevation-3" >
      Subtotal ({{numItemsString}}) : {{totalPrice}}
      <br />
      <v-btn :disabled="numItems == 0" @click="gotoCheckout">Go to Checkout</v-btn>
      <br />
      <v-btn flat @click="clearCart">Clear Cart</v-btn>
    </div>
</template>

<script>
import utils from '../../utils.ts'
import {mapState, mapGetters} from 'vuex'

export default {
  name: 'CartSubtotal',
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
    }),
    ...mapGetters('cart', {
      cartItemPrice: 'cartItemPrice',
      numItems: 'numItems'

    }),
    numItemsString: function () {
      if (this.numItems === 1) {
        return '1 item'
      } else {
        return this.numItems + ' items'
      }
    },
    totalPrice: function () {
      return utils.formatCurrency(this.cartItemPrice)
    }
  },
  methods: {
    clearCart: function () {
      this.$store.dispatch('cart/clearCart')
    },
    gotoCheckout: function () {
      const aid = this.$route.params.aid
      this.$router.push(`/${aid}/checkout`)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
